import React, {useCallback, useEffect, useRef, useState} from 'react';
import {FormContainer, Layout, LayoutChild} from "../../../../../palette/Palette";
import {db} from "../../../../../firebase/Firebase";
import {inject, observer} from "mobx-react";
import format from "date-fns/format"
import {useSnackbar} from "notistack";
import DataGrid, {Column, Pager, Paging, SearchPanel} from "devextreme-react/data-grid";
import {Popup} from 'devextreme-react/popup';
import {Button} from 'devextreme-react/button';
import axios from "axios";
import HeaderPage from "../../../../../palette/HeaderPage";
import {Animated} from "react-animated-css";
import VerticalSpace from "../../../../../palette/VerticalSpace";
import {ErrorMessage, NotiStackInfo} from "../../../../../palette/NotiStackInfo";
import Text from "../../../../../palette/Text";
import Alerts from "../../../../../palette/Alerts";

const now = new Date();

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};


const {REACT_APP_SEND_PUSH_EXPRESS} = process.env

//const url = 'http://192.168.100.3:8083/push-notifications-express'

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function ExpressPaymentValidation(props) {

    const {DataStore} = props;
    const {companyName, idCompany} = DataStore

    const year = format(now, 'yyyy')

    const mainPath = db.collection(companyName).doc(idCompany).collection('ExpressPaymentValidation')
    const mainPathReservations = db.collection(companyName).doc(idCompany).collection('Reservations')
    const mainPathBookingHistory = db.collection(companyName).doc(idCompany).collection('BookingHistory')
    const mainPathTravelStatus = db.collection(companyName).doc(idCompany).collection('TravelStatus')

    const [success, setSuccess] = useState(false)
    const [textAlert, setTextAlert] = useState('')
    const [dataSource, setDataSource] = useState([]);
    const [popupVisible, setPopupVisible] = React.useState(false);
    const [dataTrip, setDataTrip] = React.useState(null);
    const [load, setLoad] = useState(false)
    const [loading, setLoading] = useState(false)
    const [textCancel, setTextCancel] = useState('Cancelar viaje')
    const [textValidate, setTextValidate] = useState('Validar pago')
    const [bookingHistoryDocId, setBookingHistoryDocId] = useState('')
    const [travelStatusDocId, setTravelStatusDocId] = useState('')
    const [reservationDocId, setReservationDocId] = useState('')

    const {enqueueSnackbar} = useSnackbar();
    const isMounted = useMountedState()

    useEffect(() => {

        const GetTripsExpress = async () => {
            const date = format(now, 'yyyy-MM-dd')
            let ID = 0
            await mainPath.where('year', '==', year).where('date', '>=', date)
                .onSnapshot(async querySnapshot => {
                    const newArray = [];
                    querySnapshot.forEach(function (doc) {
                        ID = ID + 1
                        const obj = {...doc.data(), docId: doc.id, ID: ID};
                        newArray.push(obj);
                    });
                    setDataSource(newArray)
                    setLoading(true)
                })
        }

        if (isMounted()) {
            GetTripsExpress().catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
        }
    }, [isMounted])

    useEffect(() => {

        const GetReservation = async () => {
            await mainPathReservations.doc(dataTrip.year).collection(dataTrip.month)
                .where('date', '==', dataTrip.date)
                .where('hour', '==', dataTrip.hour)
                .get().then(querySnapshot => {
                    let uid = ''
                    querySnapshot.forEach(function (doc) {
                        uid = doc.id
                    });
                    setReservationDocId(uid)
                })
        }

        const GetIdsReport = async () => {
            await mainPathBookingHistory.doc(dataTrip.year).collection(dataTrip.month)
                .where('cod', "==", dataTrip.cod)
                .get()
                .then(function (querySnapshot) {
                    let uid = ''
                    querySnapshot.forEach(function (doc) {
                        uid = doc.id
                    });
                    setBookingHistoryDocId(uid)
                })


            await mainPathTravelStatus.doc(dataTrip.year).collection(dataTrip.month)
                .where('cod', "==", dataTrip.cod)
                .get()
                .then(function (querySnapshot) {
                    let uid = ''
                    querySnapshot.forEach(function (doc) {
                        uid = doc.id
                    });
                    setTravelStatusDocId(uid)
                })
        }

        if (isMounted()) {
            if (popupVisible) {
                GetIdsReport().catch(() => {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)

                })
                GetReservation().catch(() => {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                })
            }
        }

    }, [isMounted, popupVisible])

    const openMenu = (e) => {
        setDataTrip(e.row.data)
        setPopupVisible(true)
    }

    const buttons = [
        {
            hint: 'Reserva manual',
            icon: 'fas fa-pencil-alt',
            visible: true,
            onClick: openMenu,
        },]

    const cancelExpressTrips = async () => {
        setTextCancel('Cancelando...')
        setLoad(true)
        setTimeout(() => setTextCancel('Espere...'), 3000)

        const bookingsHistory = mainPathBookingHistory.doc(dataTrip.year).collection(dataTrip.month)
        const travelStatus = mainPathTravelStatus.doc(dataTrip.year).collection(dataTrip.month)
        const reservation = mainPathReservations.doc(dataTrip.year).collection(dataTrip.month)

        await mainPath.doc(dataTrip.docId).delete().then(() => {

            bookingsHistory.doc(bookingHistoryDocId).update({
                status: 'Cancelado'
            }).then(async () => {
                await travelStatus.doc(travelStatusDocId).update({
                    status: 'Cancelado'
                }).then(async () => {
                    await reservation.doc(reservationDocId).delete().then(() => {
                        setSuccess(true)
                        setTextAlert('Viaje cancelado exitosamente')
                        setTimeout(() => {
                            setPopupVisible(false)
                            setLoad(false)
                        }, 2000)
                    })
                })
            })
        }).catch(() => {
            setPopupVisible(false)
            setLoad(false)
            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
        });
    }

    const validateExpressTrip = async () => {

        setTextValidate('Validando...')
        setLoad(true)
        setTimeout(() => setTextValidate('Espere...'), 3000)

        const data = {
            companyName, idCompany, dataTrip, travelStatusDocId, bookingHistoryDocId, reservationDocId,
            validationDocId: dataTrip.docId
        }

        await axios.post(REACT_APP_SEND_PUSH_EXPRESS, data, {headers: headers}).then(res => {
            if (res.data === 'OK') {
                setSuccess(true)
                setTextAlert('Pago validado exitosamente')
                setTimeout(() => {
                    setPopupVisible(false)
                    setLoad(false)
                    setTextAlert('')
                    setSuccess(false)
                }, 2000)
            }

            if (res.data === 'NM') {
                setPopupVisible(false)
                setLoad(false)
                setTextAlert('')
                NotiStackInfo('Se ha generado la encomienda, pero el correo electronico no ha sido enviado', 'warning', enqueueSnackbar);
            }
        }).catch(() => {
            setTextValidate('Validar pago')
            setPopupVisible(false)
            setLoad(false)
            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
        })
    }

    return (
        <>
            {dataSource.length === 0 &&
            <LayoutChild color='transparent' percent={95} margin='auto' top={25}>
                <Alerts severity="warning" body={'Aun no existen viajes express!'}/>
            </LayoutChild>
            }

            <VerticalSpace space={30}/>
            {dataSource.length > 0 && <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <div className="grid-container">
                    <Popup
                        visible={popupVisible}
                        onHiding={() => setPopupVisible(false)}
                        dragEnabled={false}
                        closeOnOutsideClick={false}
                        showCloseButton={false}
                        showTitle={true}
                        title={`Viaje express`}
                        width={375}
                        height={'auto'}
                    >
                        <Text hover={false} size={14} weight={'600'} text={`${dataTrip?.driver}`}/>
                        <div style={{marginTop: 2}}/>
                        <Text hover={false} size={12} weight={'600'} text={`${dataTrip?.routeName}`}/>
                        <Layout color="transparent" row center>
                            <Text hover={false} size={10} weight={'400'} text={`${dataTrip?.date}`}/>
                            <Text hover={false} size={10} weight={'400'} text={`${dataTrip?.hour}`} left={10}/>
                        </Layout>
                        <div style={{marginTop: 5}}/>
                        <Layout>
                            {success && <Alerts severity={'success'} body={textAlert}/>}
                        </Layout>
                        <div style={{marginTop: 5}}/>
                        <Layout color="transparent" row center space>
                            <Button
                                width={100}
                                height={30}
                                type="normal"
                                stylingMode="outlined"
                                disabled={load}
                                onClick={() => {
                                    setLoad(false)
                                    setPopupVisible(false)
                                }}
                            >
                                <i className="far fa-arrow-alt-circle-left" style={{fontSize: '10px'}}/>
                                <span style={{fontSize: '10px', fontWeight: 'bold', marginLeft: 5}}>Salir</span>
                            </Button>
                            <Button
                                id="cancel-button"
                                width={120}
                                height={30}
                                type="success"
                                disabled={load}
                                stylingMode="contained"
                                onClick={cancelExpressTrips}
                            >
                                <i className="far fa-trash-alt" style={{fontSize: '10px', color: 'white'}}/>
                                <span style={{fontSize: '10px', fontWeight: 'bold', color: 'white', marginLeft: 5}}>
                            {textCancel}
                        </span>
                            </Button>
                            <Button
                                width={100}
                                height={30}
                                type="success"
                                disabled={load}
                                stylingMode="contained"
                                onClick={validateExpressTrip}
                            >
                                <i className="far fa-check-circle" style={{fontSize: '10px'}}/>
                                <span
                                    style={{fontSize: '10px', fontWeight: 'bold', marginLeft: 5}}>{textValidate}</span>
                            </Button>
                        </Layout>
                    </Popup>

                    <HeaderPage icon={'fas fa-comment-dollar'} text={'Validación de viajes express'} load={loading}
                                textLoad={'Cargando....'}/>
                    <FormContainer>
                        <DataGrid
                            id="express-validation"
                            dataSource={dataSource}
                            keyExpr="ID"
                            allowColumnReordering={true}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            noDataText={'Aun no existen viajes express'}
                        >
                            <SearchPanel visible={true}
                                         width={240}
                                         placeholder="Buscar"/>
                            <Paging defaultPageSize={15}/>
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[5, 10, 20]}
                                showInfo={true}/>
                            <Column dataField="cod" alignment={'center'} caption={'Cod. reserva'}/>
                            <Column dataField="driver" alignment={'center'} caption={'Conductor'}/>
                            <Column dataField="plateNumber" alignment={'center'} caption={'Num. de placa'}/>
                            <Column dataField="contactNumber" alignment={'center'} caption={'Num. de contacto'}/>
                            <Column dataField="routeName" alignment={'center'} caption={'Ruta'}/>
                            <Column dataField="date" alignment={'center'} caption={'Fecha'}/>
                            <Column dataField="hour" alignment={'center'} caption={'Hora'}/>
                            <Column dataField="passenger" alignment={'center'} caption={'Pasajero'}/>
                            <Column dataField="contact" alignment={'center'} caption={'Contacto'}/>
                            <Column dataField="statusPayment" alignment={'center'} caption={'Estado de pago'}/>
                            <Column type="buttons" width={50} buttons={buttons}/>
                        </DataGrid>
                    </FormContainer>
                </div>
            </Animated>}
        </>
    )
}

export default inject('DataStore')(observer(ExpressPaymentValidation));